import reducer from 'src/utils/redux/reducer';
import {
  RESULT_RESET_STATE,
  RESULT_SET_COLUMNS, RESULT_SET_COLUMN_ATTRIBUTES,
  RESULT_SET_ROWS, RESULT_SET_ROWS_COUNT, RESULT_SET_ROWS_TOTAL_COUNT,
  RESULT_SET_PAGE, RESULT_SET_PAGE_SIZE,
  RESULT_SET_GROUP, RESULT_TOGGLE_GROUP_ROW,
  RESULT_SET_CHECK_SATE, RESULT_TOGGLE_CHECKED_ROW,
} from './types';
import { fields } from 'src/types';

const DEFAULT_COLUMN_WIDTH = 150;

const pageSizes = [20, 50, 100, 200];

const getCheckedStateFromUUIDs = uuids => uuids.reduce((prev, uuid) => {
  prev[uuid] = false;
  return prev;
}, {});

// --- initialState ---

export const initialState = {
  columns: Object.values(fields).map(column => ({
    ...column,
    width: column.width || DEFAULT_COLUMN_WIDTH,
  })),
  rows: [],
  rowsCount: 0,
  rowsTotalCount: 0,
  groupsCount: 0,
  collapsedCount: 0,
  page: 1,
  pageSize: pageSizes[1],
  pageSizes,
  group: [],
  sort: {},
  expandedIndex: {},
  checkState: {},
};

// --- handlers ---

const handleSetInitial = () => initialState;

const handleResetState = (state, action) => ({
  ...state,
  page: initialState.page,
  expandedIndex: initialState.expandedIndex,
  checkState: getCheckedStateFromUUIDs(action.uuids),
});

const handleSetColumns = (state, action) => ({ ...state, columns: action.payload });

const handleSetColumnAttributes = (state, action) => ({
  ...state,
  columns: state.columns.map(
    column => column.name === action.columnName
      ? { ...column, ...action.payload }
      : column
  ),
});

const handleSetRows = (state, action) => ({ ...state, rows: action.payload });

const handleSetRowsCount = (state, action) => ({ ...state, rowsCount: action.count });

const handleSetRowsTotalCount = (state, action) => ({ ...state, rowsTotalCount: action.count });

const handleSetPage = (state, action) => ({ ...state, page: action.page });

const handleSetPageSize = (state, action) => ({ ...state, pageSize: action.pageSize });

const handleSetGroup = (state, action) => ({ ...state, group: action.payload });

const handleToggleGroupRow = (state, action) => {
  let expandedIndex = { ...state.expandedIndex };
  let rowsCount = state.rowsCount;

  const { row } = action;

  const isExpanded = !expandedIndex[row.index];

  if (isExpanded) {
    expandedIndex[row.index] = row.rowsCount;
    rowsCount += row.rowsCount;
  } else {
    delete expandedIndex[row.index];
    rowsCount -= row.rowsCount;
  }

  return {
    ...state,
    rowsCount,
    expandedIndex,
  };
};

const handleSetCheckState = (state, action) => ({ ...state, checkState: action.payload });

const handleToggleCheckedRow = (state, action) => ({
  ...state,
  checkState: {
    ...state.checkState,
    [action.uuid]: !state.checkState[action.uuid],
  },
});

const handlers = {
  'SET_INITIAL': handleSetInitial,
  [RESULT_RESET_STATE]: handleResetState,
  [RESULT_SET_COLUMNS]: handleSetColumns,
  [RESULT_SET_COLUMN_ATTRIBUTES]: handleSetColumnAttributes,
  [RESULT_SET_ROWS]: handleSetRows,
  [RESULT_SET_ROWS_COUNT]: handleSetRowsCount,
  [RESULT_SET_ROWS_TOTAL_COUNT]: handleSetRowsTotalCount,
  [RESULT_SET_PAGE]: handleSetPage,
  [RESULT_SET_PAGE_SIZE]: handleSetPageSize,
  [RESULT_SET_GROUP]: handleSetGroup,
  [RESULT_TOGGLE_GROUP_ROW]: handleToggleGroupRow,
  [RESULT_SET_CHECK_SATE]: handleSetCheckState,
  [RESULT_TOGGLE_CHECKED_ROW]: handleToggleCheckedRow,
};

// --- reducerFactory ---

export default flows => reducer({ initialState, handlers, flows });